import FormClient from "./FormClient";

export default function PressFormPage() {
    return <FormClient />;
}

